import { render, staticRenderFns } from "./PBTPanel.vue?vue&type=template&id=30a103c6&scoped=true&"
import script from "./PBTPanel.vue?vue&type=script&lang=js&"
export * from "./PBTPanel.vue?vue&type=script&lang=js&"
import style0 from "./PBTPanel.vue?vue&type=style&index=0&id=30a103c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a103c6",
  null
  
)

export default component.exports